import { combineReducers } from 'redux';
import Inventory, { initialState as inventoryINIT } from './rootInventory';
import { accessReducer } from './accessReducer';
import { languageReducer } from './languageReducer';
import { reportReducer } from './reportReducer';
import { paygClientReducer } from './paygClientReducer';
import { recoveryReducer } from './recoveryReducer';
import { paymentReducer } from './paymentReducer';
import { prospectReducer } from './prospectReducer';
import { statsReducer } from './statsReducer';
import { devisReducer } from './devisReducer';
import { commercialReducer } from './commercialReducer';
import { techReducer } from './techReducer';
import { spendingReducer } from './spendingReducer';
import { orderReducer } from './orderReducer';
import { notifReducer } from './notifReducer';
import { authReducer } from './authReducer';
import { societyReducer } from './societyReducer';
import { currencyReducer } from './currencyReducer';
import stockMovementReducer from './stockMovementReducer';
import { settingsReducer } from './settingsReducer';
import { superAdminProductReducer } from './superAdminProductReducer';
import { catalogueReducer } from './catalogueReducer';

import { boxReducer } from './paygAdmin/boxes';
import { subscriptionReducer } from './paygAdmin/subscriptionReducer';
import { userReducer } from './paygAdmin/users';
import { roleReducer } from './paygAdmin/roles';
import { agentReducer } from './paygAdmin/agents';
import { installerReducer } from './paygAdmin/installers';
import { schemaReducer } from './paygAdmin/schemas';
import { simReducer } from './paygAdmin/sims';
import { alertsReducer } from './paygAdmin/alerts';
import { smsReducer } from './paygAdmin/sms';
import { creditReducer } from './paygAdmin/credit';
import { agentZoneReducer } from './paygAdmin/zones';
import { extractRequest } from './paygAdmin/extract';


export const initialState = {
    language : 'fr',
    inventory:inventoryINIT,
    userPages: ['Dashboard'],
    // reportReducer:{}

};
export const rootReducer = combineReducers({
    auth: authReducer,
    language: languageReducer,
    reports: reportReducer,
    payments: paymentReducer,
    recovery: recoveryReducer,
    subscriptions: subscriptionReducer,
    clients: paygClientReducer,
    inventory: Inventory,
    userAccess: accessReducer,
    users: userReducer,
    roles: roleReducer,
    boxes: boxReducer,
    agents: agentReducer,
    installers: installerReducer,
    schemas: schemaReducer,
    sims: simReducer,
    alertsManagement: alertsReducer,
    sms: smsReducer,
    credit: creditReducer,
    extract: extractRequest,
    devis: devisReducer,
    stats: statsReducer,
    prospects: prospectReducer,
    commercialStats: commercialReducer,
    techStats: techReducer,
    zones: agentZoneReducer,
    spendings: spendingReducer,
    orders: orderReducer,
    notif: notifReducer,
    society: societyReducer,
    currency: currencyReducer,
    stockMovements: stockMovementReducer,
    settings: settingsReducer,
    superAdminProducts: superAdminProductReducer,
    catalogue: catalogueReducer,
});

